import { createContext, useContext } from 'react';
export const SearchableSelectContext = createContext(undefined);
export const useSearchableSelect = () => {
    const context = useContext(SearchableSelectContext);
    if (context === undefined) {
        throw new Error('useSearchableSelect must be used within a SearchableSelectProvider');
    }
    return context;
};
//# sourceMappingURL=SearchableSelectContext.js.map